export var CardPaymentStatusEnum;
(function (CardPaymentStatusEnum) {
    CardPaymentStatusEnum["Created"] = "Created";
    CardPaymentStatusEnum["Success"] = "Success";
    CardPaymentStatusEnum["Failed"] = "Failed";
})(CardPaymentStatusEnum || (CardPaymentStatusEnum = {}));
export var BogPaymentStatusEnum;
(function (BogPaymentStatusEnum) {
    BogPaymentStatusEnum["Created"] = "Created";
    BogPaymentStatusEnum["Success"] = "Success";
    BogPaymentStatusEnum["Failed"] = "Failed";
})(BogPaymentStatusEnum || (BogPaymentStatusEnum = {}));
//# sourceMappingURL=bog-payment-status.enum.js.map